import React from 'react';
import ReactDOM from 'react-dom/client';
import 'pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css';
import './index.css';
import App from './App';
import { getLanguage } from './i18n';
import { initializePwaInstall } from './services/PwaInstallService';
import { applyLocalizedPwaMetadata } from './services/PwaMetadataService';
import { initializeTheme } from './services/ThemeService';

initializeTheme();
applyLocalizedPwaMetadata(getLanguage());
initializePwaInstall();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
